import { createFileRoute } from '@tanstack/react-router'

import { HEAT_PUMP_CHILLER_DOMAIN } from '@/components/module-synoptic/module-synoptic-domain'
import { editRouteOptions } from '@/components/module-synoptic/module-synoptic-route-options'

// Édition d'un synoptique PAC / groupe froid. Garde OuiSense, parseParams et préchargements sont
// communs aux catégories de synoptiques à modules (cf. module-synoptic-route-options).
export const Route = createFileRoute('/_dashboard/site/$id/heat-pump/technical/manage/$synopticId/')(editRouteOptions(HEAT_PUMP_CHILLER_DOMAIN))
